// Здесь хранятся переменные окружения деплоя проекта
export enum DeployEnvironments {
  // https://cloud.vk.ru
  VkCloudRu = 'vk_cloud_ru',
  // https://vkcloud.kz
  VkCloudKz = 'vk_cloud_kz',
  // http://hrtek.vk.ru
  HRTek = 'hrtek',
  // https://workspace.vk.ru
  Workspace = 'workspace',
  // https://tarantool.io
  Tarantool = 'tarantool',
  // https://finops.vk.ru
  Finops = 'finops',
  // https://tech.vk.ru/
  Tech = 'tech',
}
